// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"354":"8d4227bf","780":"26d56fba","838":"c2dabd20"}[chunkId] + ".chunk.js";
};